import Table from './TableUserAssigned';
export default Table;